// frontend/src/components/chat/ChatLoadingAnimation.js
// Animacion de "Desencriptando" al abrir el chat

import React, { useState, useEffect } from 'react';
import './ChatLoadingAnimation.css';

const ChatLoadingAnimation = ({ isVisible, onComplete, isFirstTime = true }) => {
    const [progress, setProgress] = useState(0);
    const [currentStep, setCurrentStep] = useState(0);
    const [binaryCode, setBinaryCode] = useState('');

    const steps = [
        { text: 'Verificando identidad...', icon: '🔐' },
        { text: 'Estableciendo tunel seguro...', icon: '🔒' },
        { text: 'Sincronizando claves de cifrado...', icon: '🔑' },
        { text: 'Desencriptando mensajes...', icon: '📨' },
        { text: 'Conexion segura establecida!', icon: '✅' }
    ];

    const totalDuration = isFirstTime ? 5000 : 2000; // 5s primera vez, 2s despues

    useEffect(() => {
        if (!isVisible) return;

        // Generar codigo binario animado
        const binaryInterval = setInterval(() => {
            const newBinary = Array(50).fill(0).map(() =>
                Math.random() > 0.5 ? '1' : '0'
            ).join(' ');
            setBinaryCode(newBinary);
        }, 100);

        // Progreso
        const progressInterval = setInterval(() => {
            setProgress(prev => {
                const increment = 100 / (totalDuration / 50);
                const newProgress = Math.min(prev + increment, 100);

                // Calcular step actual basado en progreso
                const stepIndex = Math.min(
                    Math.floor((newProgress / 100) * steps.length),
                    steps.length - 1
                );
                setCurrentStep(stepIndex);

                if (newProgress >= 100) {
                    clearInterval(progressInterval);
                    clearInterval(binaryInterval);
                    setTimeout(() => {
                        onComplete && onComplete();
                    }, 500);
                }

                return newProgress;
            });
        }, 50);

        return () => {
            clearInterval(progressInterval);
            clearInterval(binaryInterval);
        };
    }, [isVisible, totalDuration, onComplete, steps.length]);

    if (!isVisible) return null;

    return (
        <div className="urbanq-loading-overlay">
            <div className="urbanq-loading-container">
                {/* Logo/Shield animado */}
                <div className="urbanq-loading-shield">
                    <div className="urbanq-loading-shield-inner">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                            <path d="M9 12l2 2 4-4"/>
                        </svg>
                    </div>
                    <div className="urbanq-loading-ring"></div>
                    <div className="urbanq-loading-ring delay-1"></div>
                    <div className="urbanq-loading-ring delay-2"></div>
                </div>

                {/* Titulo */}
                <h2 className="urbanq-loading-title">Accediendo al Chat Seguro</h2>

                {/* Barra de progreso */}
                <div className="urbanq-loading-progress-container">
                    <div className="urbanq-loading-progress-bar">
                        <div
                            className="urbanq-loading-progress-fill"
                            style={{ width: `${progress}%` }}
                        >
                            <div className="urbanq-loading-progress-glow"></div>
                        </div>
                    </div>
                    <span className="urbanq-loading-progress-text">{Math.round(progress)}%</span>
                </div>

                {/* Steps */}
                <div className="urbanq-loading-steps">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className={`urbanq-loading-step ${
                                index < currentStep ? 'completed' :
                                index === currentStep ? 'active' : ''
                            }`}
                        >
                            <span className="urbanq-loading-step-icon">
                                {index < currentStep ? '✓' : step.icon}
                            </span>
                            <span className="urbanq-loading-step-text">{step.text}</span>
                        </div>
                    ))}
                </div>

                {/* Codigo binario decorativo */}
                <div className="urbanq-loading-binary">
                    {binaryCode}
                </div>

                {/* Particulas */}
                <div className="urbanq-loading-particles">
                    {Array(20).fill(0).map((_, i) => (
                        <div
                            key={i}
                            className="urbanq-loading-particle"
                            style={{
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 2}s`,
                                animationDuration: `${2 + Math.random() * 3}s`
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChatLoadingAnimation;
